import {z} from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {PrimerComponentFaqGroupSchema} from './primerComponentFaqGroup'

export const TemplateFeaturesCopilotSchema = buildEntrySchemaFor('templateFeaturesCopilot', {
  fields: z.object({
    faqGroup: PrimerComponentFaqGroupSchema,
  }),
})

export type templateFeaturesCopilot = z.infer<typeof TemplateFeaturesCopilotSchema>
